import { ROUTE_AFFILIATE_QUOTES, ROUTE_AFFILIATE_EVENTS, ROUTE_AFFILIATE_SHIFT, ROUTE_AFFILIATE_PAY_LEVELS, ROUTE_CLIENT_QUOTES, ROUTE_CLIENT_EVENTS, ROUTE_AFFILIATE_TIMESHEET, ROUTE_CLIENT_TIMESHEET, ROUTE_CLIENT_PROFILE_MANAGE } from './staticConfigs';
import * as menuNames from './menuNamesConfigs'; 

// ********* ACTIONS FOR PUSH NOTIFICATIONS - START **********************************

export const request_a_quote                    = ROUTE_AFFILIATE_QUOTES+'/';  
export const accept_quote                       = ROUTE_AFFILIATE_EVENTS+'/';  
export const reject_quote                       = ROUTE_AFFILIATE_QUOTES+'/';  
export const event_ongoing                      = ROUTE_AFFILIATE_EVENTS+'/';  
export const event_ongoing_affiliate            = ROUTE_AFFILIATE_EVENTS+'/';  
export const shift_request                      = ROUTE_AFFILIATE_SHIFT+'/';  
export const shift_accepted                     = ROUTE_AFFILIATE_SHIFT+'/';  
export const shift_rejected                     = ROUTE_AFFILIATE_SHIFT+'/';  
export const shift_started                      = ROUTE_AFFILIATE_SHIFT+'/';  
export const shift_completed                    = ROUTE_AFFILIATE_SHIFT+'/';  
export const shift_ongoing                      = ROUTE_AFFILIATE_SHIFT+'/';  
export const shift_ongoing_affiliate            = ROUTE_AFFILIATE_SHIFT+'/';  
export const shift_affiliate_location_change    = ROUTE_AFFILIATE_SHIFT+'/';  
export const client_shift_time_change           = ROUTE_AFFILIATE_EVENTS+'/';  
export const shift_time_change_request          = ROUTE_AFFILIATE_EVENTS+'/'; 
export const send_message_affiliate             = ROUTE_AFFILIATE_EVENTS+'/'; 
export const affiliate_ot_request               = ROUTE_AFFILIATE_TIMESHEET+'/';  
export const ot_request_affiliate               = ROUTE_AFFILIATE_TIMESHEET+'/';
export const ot_request_by_crew_affiliate       = ROUTE_AFFILIATE_TIMESHEET+'/';
export const ot_request_by_chief_affiliate      = ROUTE_AFFILIATE_TIMESHEET+'/';
export const ot_request_by_crew_chief_affiliate = ROUTE_AFFILIATE_TIMESHEET+'/';
export const oe_request_affiliate               = ROUTE_AFFILIATE_TIMESHEET+'/';
export const oe_request_by_crew_affiliate       = ROUTE_AFFILIATE_TIMESHEET+'/';
export const oe_request_by_chief_affiliate      = ROUTE_AFFILIATE_TIMESHEET+'/';
export const oe_request_by_crew_chief_affiliate = ROUTE_AFFILIATE_TIMESHEET+'/';

export const send_quote                         = ROUTE_CLIENT_QUOTES+'/';  
export const affiliate_shift_time_change        = ROUTE_CLIENT_EVENTS+'/';   
export const shift_time_change_accept           = ROUTE_CLIENT_EVENTS+'/'; 
export const shift_time_change_reject           = ROUTE_CLIENT_EVENTS+'/'; 
export const send_message_client                = ROUTE_CLIENT_EVENTS+'/'; 
export const event_ongoing_client               = ROUTE_CLIENT_EVENTS+'/';  
export const shift_ongoing_client               = ROUTE_CLIENT_EVENTS+'/';  
export const client_ot_request                  = ROUTE_CLIENT_TIMESHEET+'/';   
export const ot_request_client                  = ROUTE_CLIENT_TIMESHEET+'/';
export const ot_request_by_crew_client          = ROUTE_CLIENT_TIMESHEET+'/';
export const ot_request_by_chief_client         = ROUTE_CLIENT_TIMESHEET+'/';
export const ot_request_by_crew_chief_client    = ROUTE_CLIENT_TIMESHEET+'/';
export const oe_request_client                  = ROUTE_CLIENT_TIMESHEET+'/';
export const oe_request_by_crew_client          = ROUTE_CLIENT_TIMESHEET+'/';
export const oe_request_by_chief_client         = ROUTE_CLIENT_TIMESHEET+'/';
export const oe_request_by_crew_chief_client    = ROUTE_CLIENT_TIMESHEET+'/';
export const shift_client_location_change       = ROUTE_CLIENT_EVENTS+'/';

// ********* ACTIONS FOR PUSH NOTIFICATIONS - END ************************************

// FOR NOTIFICATIONS PAGE - AFFILIATE 
export const notifiRoutesAffiliate = {
    request_a_quote             : ROUTE_AFFILIATE_QUOTES+'/',
    reject_quote                : ROUTE_AFFILIATE_QUOTES+'/',
    accept_quote                : ROUTE_AFFILIATE_EVENTS+'/',
    event_ongoing               : ROUTE_AFFILIATE_EVENTS+'/',
    event_ongoing_affiliate     : ROUTE_AFFILIATE_EVENTS+'/',
    event_completed             : ROUTE_AFFILIATE_EVENTS+'/',
    cancel_event_by_affiliate   : ROUTE_AFFILIATE_EVENTS+'/',
    shift_request               : ROUTE_AFFILIATE_SHIFT+'/',
    shift_accepted              : ROUTE_AFFILIATE_SHIFT+'/',
    shift_ongoing               : ROUTE_AFFILIATE_SHIFT+'/',
    shift_ongoing_affiliate     : ROUTE_AFFILIATE_SHIFT+'/',
    shift_rejected              : ROUTE_AFFILIATE_SHIFT+'/',
    shift_started               : ROUTE_AFFILIATE_SHIFT+'/',
    shift_completed             : ROUTE_AFFILIATE_SHIFT+'/',
    shift_location_change       : ROUTE_AFFILIATE_SHIFT+'/',
    shift_time_change           : ROUTE_AFFILIATE_SHIFT+'/',
    paylevel_update_by_affiliate: ROUTE_AFFILIATE_PAY_LEVELS+'/',
    send_message_affiliate      : ROUTE_AFFILIATE_EVENTS+'/',
    shift_time_change_accept    : ROUTE_AFFILIATE_EVENTS+'/',
    shift_time_change_reject    : ROUTE_AFFILIATE_EVENTS+'/',
    shift_time_change_request   : ROUTE_AFFILIATE_EVENTS+'/',
    affiliate_ot_request        : ROUTE_AFFILIATE_TIMESHEET+'/',
    ot_request_by_crew          : ROUTE_AFFILIATE_TIMESHEET+'/',
    oe_request                  : ROUTE_AFFILIATE_TIMESHEET+'/',
    ot_request_by_crew_chief    : ROUTE_AFFILIATE_TIMESHEET+'/',
}

// ot_request
// ot_approved
// affiliate_removal
// shift_cancelled_by_affiliate
// crew_approved_by_affiliate
// chief_approved_by_affiliate
// unavailable_by_affiliate

// FOR NOTIFICATIONS PAGE - CLIENT 
export const notifiRoutesClient = {
    request_a_quote           : ROUTE_CLIENT_QUOTES+'/',  
    reject_quote              : ROUTE_CLIENT_QUOTES+'/',
    send_quote                : ROUTE_CLIENT_QUOTES+'/',
    accept_quote              : ROUTE_CLIENT_EVENTS+'/',
    event_ongoing             : ROUTE_CLIENT_EVENTS+'/',
    event_ongoing_client      : ROUTE_CLIENT_EVENTS+'/',
    event_completed           : ROUTE_CLIENT_EVENTS+'/',
    cancel_event_by_affiliate : ROUTE_CLIENT_EVENTS+'/',
    send_message_client       : ROUTE_CLIENT_EVENTS+'/',
    shift_ongoing_client      : ROUTE_CLIENT_EVENTS+'/',
    shift_time_change_accept  : ROUTE_CLIENT_EVENTS+'/',
    shift_time_change_reject  : ROUTE_CLIENT_EVENTS+'/',
    shift_time_change_request : ROUTE_CLIENT_EVENTS+'/',
    client_certificate_expiring : ROUTE_CLIENT_PROFILE_MANAGE+'/',
    client_ot_request           : ROUTE_CLIENT_TIMESHEET+'/',
    ot_request_by_crew          : ROUTE_CLIENT_TIMESHEET+'/',
    oe_request                  : ROUTE_CLIENT_TIMESHEET+'/',
    ot_request_by_crew_chief    : ROUTE_CLIENT_TIMESHEET+'/',
    ot_request                  : ROUTE_CLIENT_TIMESHEET+'/'
}

/*
send_message
shift_time_change_to_client
shift_time_change_to_crew
*/ 

export const notifiActionDictionary = {
    "request_a_quote"             : "event_id", 
    "accept_quote"                : "event_id", 
    "reject_quote"                : "event_id", 
    "send_quote"                  : "event_id",
    "shift_request"               : "shift_id", 
    "shift_accepted"              : "shift_id", 
    "shift_rejected"              : "shift_id", 
    "shift_ongoing"               : "shift_id", 
    "shift_ongoing_affiliate"     : "shift_id", 
    "shift_ongoing_client"        : "shift_id", 
    "shift_started"               : "shift_id", 
    "shift_completed"             : "shift_id", 
    "shift_affiliate_location_change"       : "shift_id", 
    "shift_client_location_change"          : "event_id", 
    "affiliate_shift_time_change" : 'event_id',
    "client_shift_time_change"    : 'event_id', 
    "client_ot_request"           : "",
    "affiliate_ot_request"        : "",
    "event_completed"             : "event_id",
    "event_ongoing"               : "event_id",
    "event_ongoing_affiliate"     : "event_id",
    "event_ongoing_client"        : "event_id",
    "cancel_event_by_affiliate"   : "event_id", 
    "send_message_affiliate"      : "event_id", 
    "send_message_client"         : "event_id", 
    "shift_time_change_to_client" : "event_id",
    "shift_time_change_accept"    : "event_id",
    "shift_time_change_reject"    : "event_id",
    "shift_time_change_to_crew"   : "event_id", 
    "shift_time_change_request"   : "event_id",
    "client_certificate_expiring" : "",
    "ot_request"                  : "",
    "ot_request_by_crew"          : "",
    "ot_request_by_chief"         : "", 
    "ot_request_by_crew_chief"    : "",
    "oe_request"                  : "",
    "oe_request_by_crew"          : "",
    "oe_request_by_chief"         : "",
    "oe_request_by_crew_chief"    : "", 
};  

export const notifiLeftMenuActiveDictionary = {
    "request_a_quote"             : menuNames.LM_AFLT_QUOTES, 
    "accept_quote"                : menuNames.LM_AFLT_EVENTS, 
    "reject_quote"                : menuNames.LM_AFLT_QUOTES, 
    "send_quote"                  : menuNames.LM_AFLT_QUOTES, 
    "shift_request"               : menuNames.LM_AFLT_SHIFTS, 
    "shift_accepted"              : menuNames.LM_AFLT_SHIFTS, 
    "shift_ongoing"               : menuNames.LM_AFLT_SHIFTS, 
    "shift_rejected"              : menuNames.LM_AFLT_SHIFTS,  
    "shift_started"               : menuNames.LM_AFLT_SHIFTS, 
    "shift_completed"             : menuNames.LM_AFLT_SHIFTS, 
    "send_message_affiliate"      : menuNames.LM_AFLT_EVENTS,  
    "send_message_client"         : menuNames.LM_AFLT_EVENTS,  
    "shift_time_change_to_client" : menuNames.LM_AFLT_EVENTS, 
    "shift_time_change_accept"    : menuNames.LM_AFLT_EVENTS, 
    "shift_time_change_reject"    : menuNames.LM_AFLT_EVENTS, 
    "shift_time_change_to_crew"   : menuNames.LM_AFLT_EVENTS, 
    "shift_time_change_request"   : menuNames.LM_AFLT_EVENTS, 
}; 

export const NOTIFI_ACT_TYPE_QUOTE        = "quote";
export const NOTIFI_ACT_TYPE_EVENT        = "event";
export const NOTIFI_ACT_TYPE_SHIFT        = "shift";
export const NOTIFI_ACT_TYPE_OT           = "ot";
export const NOTIFI_ACT_TYPE_CLIENT       = "client";

export const notifiActionTypes = { 
    "request_a_quote"             : NOTIFI_ACT_TYPE_QUOTE, 
    "send_quote"                  : NOTIFI_ACT_TYPE_QUOTE,
    "accept_quote"                : NOTIFI_ACT_TYPE_QUOTE,
    "reject_quote"                : NOTIFI_ACT_TYPE_QUOTE,
    "shift_request"               : NOTIFI_ACT_TYPE_SHIFT,
    "shift_accepted"              : NOTIFI_ACT_TYPE_SHIFT,
    "shift_rejected"              : NOTIFI_ACT_TYPE_SHIFT,
    "shift_started"               : NOTIFI_ACT_TYPE_SHIFT,
    "shift_completed"             : NOTIFI_ACT_TYPE_SHIFT,
    "ot_approved"                 : NOTIFI_ACT_TYPE_OT,
    "affiliate_shift_time_change" : NOTIFI_ACT_TYPE_EVENT,
    "client_shift_time_change"    : NOTIFI_ACT_TYPE_EVENT,
    "client_ot_request"           : NOTIFI_ACT_TYPE_OT,
    "affiliate_ot_request"        : NOTIFI_ACT_TYPE_OT,
    "send_message_affiliate"      : NOTIFI_ACT_TYPE_EVENT,  
    "send_message_client"         : NOTIFI_ACT_TYPE_EVENT,  
    "shift_time_change_to_client" : NOTIFI_ACT_TYPE_EVENT, 
    "shift_time_change_accept"    : NOTIFI_ACT_TYPE_EVENT, 
    "shift_time_change_reject"    : NOTIFI_ACT_TYPE_EVENT, 
    "shift_time_change_to_crew"   : NOTIFI_ACT_TYPE_EVENT, 
    "shift_time_change_request"   : NOTIFI_ACT_TYPE_EVENT, 
    "client_certificate_expiring" : NOTIFI_ACT_TYPE_CLIENT, 
    "ot_request"                  : NOTIFI_ACT_TYPE_OT, 
    "ot_request_by_crew"          : NOTIFI_ACT_TYPE_OT, 
    "ot_request_by_chief"         : NOTIFI_ACT_TYPE_OT, 
    "ot_request_by_crew_chief"    : NOTIFI_ACT_TYPE_OT,
    "oe_request"                  : NOTIFI_ACT_TYPE_OT, 
    "oe_request_by_crew"          : NOTIFI_ACT_TYPE_OT,
    "oe_request_by_chief"         : NOTIFI_ACT_TYPE_OT,
    "oe_request_by_crew_chief"    : NOTIFI_ACT_TYPE_OT,
};  

// "rating_by_crew_chief"        : NOTIFI_ACT_TYPE_OT,
// "review_by_crew_chief"        : NOTIFI_ACT_TYPE_OT,

